module.exports = "pegasus/assets/hexagon-twitter.png";